import tw from "twin.macro";
import moneyImageSrc from "images/money.svg";

const Image = tw.img`w-144 ml-auto`;

export default () => <Image src={moneyImageSrc} />;